import api from 'utils/api';
import { slotConfig } from 'utils/api';

export const EConsentService = {
    postClaimWithResponse: (body: any): any => {
        return api.post(`${process.env.REACT_APP_ECONSENT_API_URL}`, body, slotConfig);
    }
};
